import React, { useState, useEffect } from 'react';
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';
import { makeStyles } from '@material-ui/core/styles';
import { cardTitle } from 'assets/jss/material-dashboard-pro-react.js';

import { Create, Add, DirectionsWalkSharp, DirectionsWalkRounded, Apps } from '@material-ui/icons';

import GridContainer from 'components/Grid/GridContainer.js';
import GridItem from 'components/Grid/GridItem.js';
import Button from 'components/CustomButtons/Button.js';
import Card from 'components/Card/Card.js';
import CardBody from 'components/Card/CardBody.js';
import CardIcon from 'components/Card/CardIcon.js';
import CardHeader from 'components/Card/CardHeader.js';
import ReactTable from 'components/ReactTable/ReactTable.js';
import LoadingSpinner from 'components/Tvendo/Common/LoadingSpinner';

import { wsGetAll } from 'services/WService.js';

import ModalDistributionStaff from './Modal';
import { useModal } from 'hooks/useModal';
import { Toasty, useToasty } from 'hooks/Toasty';
import ButtonDelete from 'hooks/ButtonDelete';
import { WithApp } from 'contexts/appContext';
import RegularButton from 'components/CustomButtons/Button';
import UserAppModal from 'components/Tvendo/Setting/User/UserAppModal';
import ButtonResetPassword from 'components/Tvendo/Common/ButtonResetPassword';

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: '15px',
    marginBottom: '0px'
  }
});

const columns = [
  { Header: '#', accessor: 'num', excelEnabled: false, width: 160 },
  { Header: 'Código', accessor: 'code', width: 130, align: 'center' },
  { Header: 'Nombre completo', accessor: 'name' },
  { Header: 'Nombres', accessor: 'FirstName' },
  { Header: 'Apellidos', accessor: 'LastName' },
  { Header: 'Zona', accessor: 'base_zone_description', width: 130, align: 'center' },
  { Header: 'Lic. conducir', accessor: 'driver_license', width: 120, align: 'center' },
  { Header: 'Estado Empleado', accessor: 'base_employee_status_description', width: 180 },
  {
    Header: 'Posición Empleado',
    accessor: 'base_employee_position_description',
    width: 180
  },
  { Header: 'Liq. Múltiple', accessor: 'massive_liquidation', width: 120, align: 'center' },
  { Header: 'Tipo liquidación', accessor: 'tipo_comision', width: 145 },
  { Header: '', accessor: 'actions', width: 0 }
];

export default WithApp(function DistributionStaff(props) {
  const classes = useStyles();
  const [model, setOpen] = useModal();
  const [notify, showNotify] = useToasty();
  const [distributionStaffs, setDistributionStaff] = useState([]);
  const [dataLoading, setDataLoading] = useState(false);
  const [appModel, setAppModel] = useModal();

  async function loadEmployeeStatus() {
    setDataLoading(true);
    let response = await wsGetAll('prog/distribution-staff');
    setDataLoading(false);
    if (response.success) setDistributionStaff(response.data);
  }

  useEffect(() => {
    loadEmployeeStatus();
  }, []);

  return (
    <GridContainer>
      <Toasty action={notify} />
      <ModalDistributionStaff
        model={model}
        setOpen={setOpen}
        showNotify={showNotify}
        reload={loadEmployeeStatus}
      />
      <UserAppModal
        model={appModel}
        setOpen={setAppModel}
        showNotify={showNotify}
        canDelete={false}
        reload={loadEmployeeStatus}
      />
      <GridItem xs={12}>
        <Card>
          <CardHeader icon>
            <AllowedGuard
              permission={ConstantPermissions.PROG_DISTRIBUTION_STAFF_STORE}
              component={
                <CardIcon color="primary">
                  <DirectionsWalkRounded style={{ color: 'white' }} />
                </CardIcon>
              }
            >
              <CardIcon
                onClick={() => setOpen({})}
                pointer="true"
                color={props.themeContext.buttonColorSuccess}
              >
                <Add />
              </CardIcon>
            </AllowedGuard>
            <h4 className={classes.cardIconTitle}>Listado de personal de distribución {dataLoading && <LoadingSpinner />}</h4>
          </CardHeader>
          <CardBody>
            <ReactTable
              excelName="Personales-de-distribución"
              defaultWidth={1500}
              columns={columns}
              data={distributionStaffs.map((item, i) => {
                return {
                  num: (
                    <div className="actions-right">
                      {i + 1}
                      <AllowedGuard permission={ConstantPermissions.PROG_DISTRIBUTION_STAFF_UPDATE}>
                        <Button
                          justIcon
                          round
                          simple
                          color="info"
                          className="like"
                          onClick={() => setOpen(item)}
                        >
                          <Create />
                        </Button>
                      </AllowedGuard>
                      <AllowedGuard
                        permission={ConstantPermissions.PROG_DISTRIBUTION_STAFF_DELETED}
                      >
                        <ButtonDelete
                          entity="prog/distribution-staff"
                          id={item.id}
                          reload={loadEmployeeStatus}
                        />
                      </AllowedGuard>
                      <AllowedGuard permission={ConstantPermissions.PROG_DISTRIBUTION_STAFF_UPDATE}>
                        <RegularButton
                          justIcon
                          round
                          simple
                          color="info"
                          onClick={() => setAppModel(item?.user)}
                          disabled={item?.user === null || item?.user === undefined}
                        >
                          <Apps />
                        </RegularButton>
                      </AllowedGuard>
                      <AllowedGuard permission={ConstantPermissions.ADMIN_ACCESS_USER_CHANGE_PASSWORD}>
                        <ButtonResetPassword userId={item?.user?.id} nombre={item.name} />
                      </AllowedGuard>
                    </div>
                  ),
                  code: item.code,
                  name: item.name,
                  FirstName: item.FirstName,
                  LastName: item.LastName,
                  base_zone_description: item.base_zone_description,
                  driver_license: item.driver_license,
                  base_employee_status_description: item.base_employee_status_description,
                  base_employee_position_description: item.base_employee_position_description,
                  massive_liquidation: item.massive_liquidation === 'Y' ? 'Si' : 'No',
                  tipo_comision: item.tipo_comision === "1" ? 'Tipo comisión 1' : 'Tipo comisión 2',
                  actions: ''
                };
              })}
            />
          </CardBody>
        </Card>
      </GridItem>
    </GridContainer>
  );
});
